// extracted by mini-css-extract-plugin
module.exports = {"svg":"sharedStyles-module__svg___3Ge5G","connect":"sharedStyles-module__connect___6eeAB"};